import { useAuth } from '@/AuthProvider';
import defaultValues from '@/constant/defaultValues';
import { lowerCase } from 'lodash';
import companylogo from "@/images/Company-logo.svg";
import React from 'react';

function SupplierCard({ data, handleQuoteClick }) {

  const { BASE_URL } = defaultValues.IMAGE_PATH
  const { user, isEndUser, isPreKYCUser } = useAuth();

  console.log("Data ========= ", data);

  return (
    <div className='gray-pad'>
      <div className='info-pad pb-3'>
        {/* <div className='thum-wrape'>
          <img src={data.company_logo ? BASE_URL + data.company_logo : companylogo} alt={data.company_name} />
        </div> */}
        <div className='detail'>
          <h4 title={data && data.company_name}>{data.company_name}</h4>

          {
              data && <span className='price-qty mp-supplier-price-qty'> {data.industy_name}</span>
          }

          <div className='flag-section mt-4'>
            {/* <i className='flag'></i> */}
            

            {data && data.country && <img src={require(`@/assets/images/svg/flag/${lowerCase(data.country?.iso3)}.svg`)} alt="" style={{ height: 24, width: 24 }} />}
            <span>{data.shipment_mode}</span>
          </div>
          {/* <span>{data.products_count} Products</span> */}
        </div>
      </div>
      {/* <p>{data.about_company}</p> */}

      {
        (user === null || (user && user.trade_mode_type !== "LOG_PTR" && (isEndUser || isPreKYCUser) && user.member_id != data.id)) && <div className="btn-wrape">

          <button type="button" className="btn outline medium" onClick={() => handleQuoteClick(data)}>
            Contact Supplier
            <span className="round">
              <i className="sprite"></i>
            </span>
          </button>
        </div>
      }

    </div>
  )
}

export default SupplierCard
